<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <div class="page-wrapper" ref="formContainer">
      <div class="content container-fluid">
        <!-- PAGE HEADER -->
        <reports-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :search_data="searchform"
          :columns="originalColumn"
          :hasExportPermission="hasExportPermission"
        />

        <!-- TEAM AVAILABILITY PAGE -->
        <div class="row mt-4">
          <div class="col-md-12">
            <div class="timeline-wrapper">
              <!-- CALENDAR TITLE -->
              <div class="timeline-header">
                <div>
                  <div class="timeline-title">Team Availability</div>
                  <div class="timeline-subtitle">
                    {{ formattedRange }}
                  </div>
                </div>

                <div class="total-off">
                  <div class="total-label">Total Days Off</div>
                  <div class="total-value">{{ totalDaysOff }}</div>
                </div>
              </div>

              <!-- TOP FILTER BAR -->
              <div class="filters-bar">
                <!-- DATE PICKER (Range) -->
                <!-- <input type="date" v-model="filters.start" @change="updateDateRange"/>
                <input type="date" v-model="filters.end" @change="updateDateRange"/> -->

                <div class="col-sm-6 col-md-2">
                  <div class="input-block mb-3 form-focus focused">
                    <div class="cal-icon">
                      <datepicker
                        v-model="filters.start"
                        placeholder="Choose Date"
                        class="form-control floating datetimepicker"
                        :editable="true"
                        :clearable="false"
                        :input-format="dateFormat"
                        @update:model-value="updateDateRange"
                      />
                      <label class="focus-label">Start Date</label>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <div class="input-block mb-3 form-focus focused">
                    <div class="cal-icon">
                      <datepicker
                        v-model="filters.end"
                        placeholder="Choose Date"
                        class="form-control floating datetimepicker"
                        :editable="true"
                        :clearable="false"
                        :input-format="dateFormat"
                        @update:model-value="updateDateRange"
                      />
                      <label class="focus-label">End Date</label>
                    </div>
                  </div>
                </div>

                <!-- SEARCH EMPLOYEE -->
                <div class="col-sm-6 col-md-2">
                  <div class="input-block mb-2 form-focus focused">
                    <input
                      type="text"
                      class="form-control floating"
                      v-model="filters.search"
                      placeholder="Search employee"
                      @input="filterEmployees"
                    />
                  </div>
                </div>
                <!-- TEAM FILTER -->
                <!-- <select class="selector"><option>All Teams</option></select> -->

                <!-- LEAVE TYPE FILTER -->
                <!-- <select
                  class="selector"
                  v-model="filters.leaveType"
                  @change="filterLeaves"
                >
                  <option value="">All Leave Types</option>
                  <option v-for="t in leaveTypes" :key="t">{{ t }}</option>
                </select> -->
                <div class="col-sm-6 col-md-2">
                  <div class="input-block mb-2 form-focus focused">
                    <vue-select
                      :options="leaveTypes"
                      v-model="filters.leaveType"
                      placeholder="-"
                      id="designationList"
                      @update:modelValue="onSearch"
                    />
                    <label class="focus-label">Select Leave Type</label>
                  </div>
                </div>
              </div>

              <!-- CALENDAR -->
              <DayPilotScheduler
                ref="calendar"
                :config="config"
                class="scheduler"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { DayPilot, DayPilotScheduler } from "@daypilot/daypilot-lite-vue";

export default {
  components: { DayPilotScheduler },

  data() {
    const defaultAvatar = require("@/assets/img/profiles/avatar-01.jpg");

    const currentDate = new Date();
    const lastWeekDate = new Date();
    lastWeekDate.setDate(currentDate.getDate() - 15);

    return {
      title: "Team Availability",
      path: "Dashboard",
      text: "Team Availability",
      text1: "Export Excel",
      dateFormat: "dd-MM-yyyy",
      // FILTERS
      filters: {
        start: lastWeekDate,
        end: currentDate,
        search: "",
        leaveType: "",
      },
      employeesMaster: [],
      eventsMaster: [],
      leaveTypes: ["Vacation", "Sick Leave", "WFH", "Training", "Remote Work"],

      config: {
        startDate: lastWeekDate,
        days: 15,
        scale: "Day",
        cellWidth: 64,
        rowHeight: 200,
        headerHeight: 40,

        rowHeaderWidth: 240,
        eventHeight: 64,
		
		eventMoveHandling: "Disabled",
		eventResizeHandling: "Disabled",
		timeRangeSelectedHandling: "Disabled",

        timeHeaders: [
          { groupBy: "Month", format: "MMMM yyyy" },
          { groupBy: "Day", format: "ddd d" },
        ],

        borderColor: "#e6e6e6",
        cellBackColor: "#ffffff",

        resources: [],
        events: [],

        // EMPLOYEE COLUMN
        onBeforeRowHeaderRender: (args) => {
		  const e = args.row.data;

		  args.row.areas = [
			{
			  left: 14,
			  top: 12,
			  width: 46,
			  height: 46,
			  html: `<img src="${e.avatar}" class="emp-avatar">`,
			},
			{
			  left: 72,
			  top: 12,
			  html: `
				<div class="emp-name">Member ${e.id}</div>
				<div class="emp-role">${e.role || ""}</div>
			  `,
			},
		  ];
		},

        // EVENT BLOCKS
        onBeforeEventRender: (args) => {
          args.data.areas = [
            {
              top: 6,
              left: 6,
              right: 6,
              bottom: 6,
              style: `
                background-color:${args.data.backColor};
                border-radius:8px;
                color:white;
                padding:4px 10px;
                font-size:13px;
                font-weight:600;
                display:flex;
                align-items:center;
                box-shadow:0 2px 4px rgba(0,0,0,0.15);
              `,
              html: args.data.type,
            },
          ];
        },

        // TOOLTIP COMPATIBLE WITH LITE
        eventHoverHandling: "Title",
      },
    };
  },

  computed: {
    formattedRange() {
      return `${this.filters.start} – ${this.filters.end}`;
    },
    totalDaysOff() {
      return this.config.events.length;
    },
  },

  mounted() {
  
	this.fetchAvailability();
	
    this.applyFilters();
  },
  methods: {
	countDays(start, end) {
	  const s = new Date(start);
	  const e = new Date(end);

	  if (isNaN(s.getTime()) || isNaN(e.getTime())) {
		console.error("Invalid dates passed to countDays:", start, end);
		return 1;
	  }

	  // Make end inclusive
	  e.setDate(e.getDate() + 1);

	  const diff = (e - s) / (1000 * 60 * 60 * 24);
	  return diff;
	},
	parseAPIDate(dateStr) {
	  // Case 1: API already returns ISO (2025-12-01)
	  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
		return dateStr;
	  }

	  // Case 2: Convert "01 Dec 2025" → "2025-12-01"
	  const months = {
		Jan: "01",
		Feb: "02",
		Mar: "03",
		Apr: "04",
		May: "05",
		Jun: "06",
		Jul: "07",
		Aug: "08",
		Sep: "09",
		Oct: "10",
		Nov: "11",
		Dec: "12",
	  };

	  const parts = dateStr.split(" "); // ["01", "Dec", "2025"]
	  const day = parts[0];
	  const month = months[parts[1]];
	  const year = parts[2];

	  return `${year}-${month}-${day}`;
	},
	fetchAvailability(params = null) {
      const token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/teamavailability", params) // 
        .then((response) => {
          const members = response.data.data.selectedmembers;
          this.apiMembers = members;

          const range = members[0].attendancereport.range_used;

         const startISO = this.parseAPIDate(range.start);
		const endISO   = this.parseAPIDate(range.end);

		this.filters.start = new Date(startISO);
		this.filters.end   = new Date(endISO);

		this.config.startDate = startISO;
		this.config.days = this.countDays(startISO, endISO);

          this.buildResources();
          this.buildEvents();

          this.$refs.calendar.control.update();

          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          console.error("API ERROR:", error);
        });
    },
	buildResources() {
	  if (!this.apiMembers) return;

	  this.config.resources = this.apiMembers.map(m => ({
		id: String(m.member_id),
		label: "Member " + m.member_id,   // 👈 use this for display
		role: "",
		avatar: require("@/assets/img/profiles/avatar-01.jpg"),
	  }));

	  this.$refs.calendar.control.update();
	},
	buildEvents() {
	  let events = [];

	  this.apiMembers.forEach((member) => {
		const id = member.member_id;

		member.attendancereport.dates.forEach((d, index) => {
		  if (d.is_leave) {
			const startISO = this.parseAPIDate(d.date);
			const nextDay = new Date(startISO);
			nextDay.setDate(nextDay.getDate() + 1);

			events.push({
			  id: `${id}-${index}`,
			  resource: String(id),
			  start: startISO,
			  end: nextDay.toISOString().split("T")[0],
			  type: d.leave_type || "Leave",
			  backColor: "#F44336",
			});
		  }
		});
	  });

	  this.config.events = events;

	  if (this.$refs.calendar?.control) {
		this.$refs.calendar.control.update();
	  }
	},
    updateDateRange() {
      const start = new Date(this.filters.start);
      const end = new Date(this.filters.end);
	  
	  const endInclusive = new Date(end);
	  endInclusive.setDate(endInclusive.getDate() + 1);
	  
      //const diff = (end - start) / (1000 * 3600 * 24);
	  
	  const diff = (endInclusive - start) / (1000 * 3600 * 24);

      
	  this.config.startDate = this.filters.start;
	  
      //this.config.days = diff + 1;
	  
	  this.config.days = diff;

      this.applyFilters();
    },

    filterEmployees() {
      this.applyFilters();
    },

    filterLeaves() {
      this.applyFilters();
    },

    applyFilters() {
      let emps = [...this.employeesMaster];
      let evts = [...this.eventsMaster];

      // SEARCH FILTER
      if (this.filters.search) {
        emps = emps.filter((e) =>
          e.name.toLowerCase().includes(this.filters.search.toLowerCase())
        );
      }

      // LEAVE TYPE FILTER
      if (this.filters.leaveType !== "") {
        evts = evts.filter((e) => e.type === this.filters.leaveType);
      }

      // ASSIGN FILTERED DATA
      this.config.resources = emps;
      this.config.events = evts;

      if (this.$refs.calendar?.control) {
        this.$refs.calendar.control.update();
      }
    },
  },
};
</script>

<style scoped>
.timeline-wrapper {
  background: #fff;
  padding: 15px;
}


/* INNER HEADER */
.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.timeline-title {
  font-size: 18px;
  font-weight: 700;
}

.timeline-subtitle {
  font-size: 13px;
  color: #777;
  margin-top: 2px;
}

.timeline-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pill-btn {
  border-radius: 999px;
  padding: 5px 14px;
  border: 1px solid #d0d0d0;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
}

.pill-active {
  background: #1e88e5;
  color: #fff;
  border-color: #1e88e5;
}

.filter-select {
  border-radius: 999px;
  border: 1px solid #d0d0d0;
  padding: 4px 10px;
  font-size: 12px;
  background: #fff;
}

.total-off {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 6px 10px;
  min-width: 100px;
}

.total-label {
  font-size: 11px;
  color: #666;
}

.total-value {
  font-size: 16px;
  font-weight: 700;
}

/* EMPLOYEE COLUMN */
.emp-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.emp-name {
  font-size: 14px;
  font-weight: 600;
}

.emp-role {
  font-size: 12px;
  color: #777;
}

.scheduler_default_rowheader {
  min-height: 160px !important;
}

/* FLOATING SUMMARY BOX */
.floating-box {
  position: absolute;
  right: 25px;
  top: 82px;
  background: #fff;
  padding: 16px 18px;
  border-radius: 12px;
  width: 260px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
}

.floating-box h4 {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 700;
}

.floating-box ul {
  margin: 0;
  padding-left: 18px;
}

.floating-box li {
  font-size: 13px;
  margin-bottom: 6px;
}

/* GRID CLEANUP */
.scheduler_default_corner_inner,
.scheduler_default_rowheader_inner,
.scheduler_default_timeheader_inner {
  background: #ffffff !important;
}

.scheduler_default_timeheader_cell {
  font-size: 13px !important;
  color: #444 !important;
}

.scheduler_default_timeheader_cell:not(:first-child) {
  border-left: 1px solid #e6e6e6;
}

.scheduler_default_cell {
  background: #ffffff !important;
  border-right: 1px solid #e6e6e6 !important;
  border-bottom: 1px solid #e6e6e6 !important;
}

.filters-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
}

.search-input {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  width: 200px;
}

.selector {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.emp-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}


</style>
